export var AccountEvent;
(function (AccountEvent) {
    AccountEvent["SignedInOrRegistered"] = "SignedInOrRegistered";
    AccountEvent["SignedOut"] = "SignedOut";
})(AccountEvent || (AccountEvent = {}));
